module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe40066d95348fc239dd2466cc6f106e8.e40066d9.png";